import Vue from 'vue'
const CryptoJS = require("crypto-js")

//回调函数的xhr请求
export function communicate(apiurl, postData, cb) {
  postData.head.auth = globalstore.state.user.auth
  postData.head.auth2 = globalstore.state.user.auth2

  postData.head.auth = head.auth
  postData.head.auth2 = head.auth2
  Vue.prototype.$axios.post(apiurl, postData).then(
    (res) => {
      // console.log(55)
      cb && cb(res)
    },
    (err) => {
      console.log(err)
    }
  )
}

//promise方式的xhr请求
export function httpPromise(apiurl, postData, cb) {
  postData.head.auth = globalstore.state.user.auth
  postData.head.auth2 = globalstore.state.user.auth2

  postData.head.auth = head.auth
  postData.head.auth2 = head.auth2

  return new Promise((resolve, reject) => {
    Vue.prototype.$axios.post(apiurl, postData).then(
      (res) => {
        resolve(res)
      },
      (err) => {
        $.alert('请求错误')
      }
    )
  })
}

export function get(data) {
  var click_img = new Image()

  var baseUrl = Global_apiserver + '/api/csco/clickstream'

  var result = ''
  for (let k in data) {
    result += k + '=' + data[k] + '&'
  }

  result = baseUrl + '?' + result.substr(0, result.length - 1)

  // console.log(result)

  click_img.src = result
}

// 美化时间
export const goodTime = (str) => {
  let now = new Date().getTime()
  // let oldTime = new Date(str).getTime()
  let oldTime = str * 1000
  let difference = now - oldTime
  let result = ''
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  // let halfamonth = day * 15
  let month = day * 30
  let year = month * 12

  let _year = difference / year
  let _month = difference / month
  let _week = difference / (7 * day)
  let _day = difference / day
  let _hour = difference / hour
  let _min = difference / minute

  if (_year >= 1) {
    result = ~~_year + ' 年前'
  } else if (_month >= 1) {
    result = ~~_month + ' 月前'
  } else if (_week >= 1) {
    result = ~~_week + ' 周前'
  } else if (_day >= 1) {
    result = ~~_day + ' 天前'
  } else if (_hour >= 1) {
    result = ~~_hour + ' 小时前'
  } else if (_min >= 1) {
    result = ~~_min + ' 分钟前'
  } else result = '刚刚'
  return result
}


export const formatTime = (t, fmt, idAddZero = true) => {
  /**
   * t: 传入的元数据
   * fmt： 格式化的时间格式，EE: 显示周几，EEE：显示星期几
   * idAddZero: 是否需要在末尾添加  000
   */
  if (!t) return undefined;
  if (typeof t == 'string' &&  t.includes('-')) t = t.replace(/-/g, '/');
  let time = idAddZero ? new Date(t * 1000) : new Date(t);
  let o = {
    "M+": time.getMonth() + 1, // 月份
    "d+": time.getDate(), // 日
    "h+": time.getHours() % 12 === 0 ? 12 : time.getHours() % 12, // 小时
    "H+": time.getHours(), // 小时
    "m+": time.getMinutes(), // 分
    "s+": time.getSeconds(), // 秒
    "q+": Math.floor((time.getMonth() + 3) / 3), // 季度
    S: time.getMilliseconds(), // 毫秒
  };
  let week = {
    "0": "天",
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六",
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (time.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? "星期" : "周") : "") +
        week[time.getDay() + ""]
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? o[k]
          : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}

export const regExp = {
  // 手机号不正确就返回   true
  mobile: str => {
    return (/^1[3456789]\d{9}$/.test(str)) ? false : true
  }
}


let status = 0;
export const supportSafeArea = () => {
  if (status !== 0) {
    // 缓存数据，只向 body 插入一次 dom 即可
    return status === 1;
  }
  const div = document.createElement('div');
  const id = 'test-check-safe-area';
  const styles = [
    'position: fixed',
    'z-index: -1',
    'height: constant(safe-area-inset-top)',
    'height: env(safe-area-inset-top)',
  ];
  div.style.cssText = styles.join(';');
  div.id = id;
  document.body.appendChild(div);
  const areaDiv = document.getElementById(id);
  if (areaDiv) {
    status = areaDiv.offsetHeight === 0 ? 1 : -1; // 该 div 的高度是否为 0
    areaDiv.parentNode && areaDiv.parentNode.removeChild(areaDiv);
  }
  return status === 1;
};

// 判定来源（wclc2024与esmo2024使用，后期不更新维护）
export const sourceType = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/MicroMessenger/i.test(ua)) {
    if (/iphone/i.test(ua)) {
      return 'wx_iOS'
    } else if (/android/i.test(ua)) {
      return 'wx_Android'
    }
  } else {
    if (/iphone/i.test(ua)) {
      return 'Web_iOS'
    } else if (/android/i.test(ua)) {
      return 'Web_Android'
    }
  }
}

// 判定系统（wclc2024与esmo2024使用，后期不更新维护）
export const getOS = () => {
  let u = navigator.userAgent
  if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
    return 'windows'
  } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
    return 'macOS'
  } else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
    return 'iOS'
  } else if (u.match(/android/i)) {
    return 'Android'
  } else if (u.match(/Ubuntu/i)) {
    return 'Ubuntu'
  }  else if (u.match(/arkweb/i)) {
    return 'HarmonyOS'
  } else {
    return 'other'
  }
}

// 加密方法
export function encrypt(key, data) {
  // 十六位十六进制数作为密钥
  const SECRET_KEY = CryptoJS.enc.Utf8.parse(key)
  // 十六位十六进制数作为密钥偏移量
  const SECRET_IV = CryptoJS.enc.Utf8.parse('ldM&)&ldM&)&ldM&')

  if (typeof data === 'object') {
    data = JSON.stringify(data)
  } else {
    data = data.toString()
  }

  const dataHex = CryptoJS.enc.Utf8.parse(data)
  const encrypted = new CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return encrypted.toString()
}

/**
 * 检查用户信息是否完善并且认证成功
 * @param {Object} options - 配置选项
 * @param {Object} options.that - Vue实例（通常是 this）
 * @param {Function} options.axios - axios实例（通常是 this.$axios 或 Vue.prototype.$axios）
 * @param {Function} options.Dialog - Dialog组件（通常是 vant 的 Dialog）
 * @param {Function} options.Toast - Toast组件（通常是 vant 的 Toast）
 * @param {Object} options.router - Vue Router实例（通常是 this.$router）
 * @param {Object} options.store - Vuex Store实例（通常是 this.$store）
 * @param {Function} options.onSuccess - 检查通过时的回调函数
 * @param {String} options.pageSource - 页面来源标识（可选，用于跳转完善信息页面时的参数）
 * @param {Boolean} options.showCancelButton - 是否显示取消按钮，默认为true
 * @returns {Promise} 返回Promise，resolve时表示检查通过，reject时表示检查未通过或出错
 */
export async function checkUserInfoAndAuth(options = {}) {
  const { that, axios, Dialog, Toast, router, store, onSuccess, pageSource = '', showCancelButton = true } = options

  if (!axios) {
    console.error('checkUserInfoAndAuth: axios参数是必需的')
    return Promise.reject(new Error('axios参数是必需的'))
  }

  try {
    const apiurl = Global_apiserver + 'api/user/checkInfoComplete'
    head.cver = '9.4'
    const postData = {
      head,
    }
    const response = await axios.post(apiurl, postData)

    if (response && response.data && response.data.responseStatus && response.data.responseStatus.errors.length == 0) {
      const res = response.data
      // isComplete: 0-未完善，1-已完善
      // onlyLackDisease: 1-只是缺少擅长瘤肿
      // level: 0-未认证，1-未认证，2-已认证，3-未通过，4-审核中
      const isComplete = res.isComplete === 1
      const isAuth = res.level === 2

      if (isComplete && isAuth) {
        // 信息已完善且认证成功，执行成功回调
        if (Toast) {
          Toast.clear()
        }
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
        return Promise.resolve(res)
      } else {
        // 信息未完善或未认证，显示提示弹框
        if (!Dialog || !Toast || !router || !store || !that) {
          console.warn('checkUserInfoAndAuth: Dialog, Toast, router, store 参数不完整，无法显示弹框')
          if (Toast) {
            Toast.clear()
          }
          return Promise.reject(new Error('用户信息未完善或未认证'))
        }

        let message = ''
        if (isComplete == 0) {
          message = '请先完善信息后才能参与，是否前往完善？'
        } else if (isComplete == 1 && isAuth != 2) {
          message = '请先完成认证并认证成功后才能参与，是否前往认证？'
        }

        if (Toast) {
          Toast.clear()
        }

        return new Promise((resolve, reject) => {
          Dialog.confirm({
            title: '提示',
            message: message,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: showCancelButton,
            closeOnClickOverlay: false,
          })
            .then(() => {
              // 确定按钮 - 跳转到完善信息或认证页面
              if (!isComplete) {
                // 跳转到完善信息页面
                store.dispatch('getUserInfoPromise').then(() => {
                  const redirectUri = encodeURIComponent(window.location.href)
                  const pageSourceParam = pageSource ? `&page_source=${pageSource}` : ''
                  window.location.href = Global_userCenter_serve + `edit-authentication-info?redirect_uri=${redirectUri}${pageSourceParam}`
                })
              } else if (!isAuth) {
                // 跳转到认证页面
                that.$root.goToCertify(pageSource)
              }
              reject(new Error('用户需要完善信息或认证'))
            })
            .catch(() => {
              // 取消按钮 - 不执行任何操作
              reject(new Error('用户取消操作'))
            })
        })
      }
    } else {
      const errorMsg = response.data?.responseStatus?.errors?.[0]?.message || '检查用户信息失败'
      if (Toast) {
        Toast.clear()
        Toast(errorMsg)
      }
      return Promise.reject(new Error(errorMsg))
    }
  } catch (error) {
    console.error('检查用户信息失败:', error)
    if (Toast) {
      Toast.clear()
      Toast('检查用户信息失败，请重试')
    }
    return Promise.reject(error)
  }
}

/**
 * 根据项目ID或加密后的案例ID检查用户状态（用于项目相关场景）
 * 功能：按顺序判断用户是否是医生及是否已认证（isDoctor === 1 && level === 2），
 *      然后判断是否在指定医院（isInSpecifiedHospital === 1），
 *      最后判断劳务是否完善（perfectStatus === 1）
 * @param {Object} options - 配置选项
 * @param {Function} options.axios - axios实例（通常是 this.$axios 或 Vue.prototype.$axios）
 * @param {Function} options.Dialog - Dialog组件（通常是 vant 的 Dialog）
 * @param {Function} options.Toast - Toast组件（通常是 vant 的 Toast）
 * @param {String|Number} options.projectId - 项目ID（不需要加密），与encryptedCaseId二选一
 * @param {String} options.encryptedCaseId - 加密后的案例ID，与projectId二选一
 * @param {String|Number} options.signType - 默认不存在
 * @param {Function} options.onSuccess - 检查通过时的回调函数，参数：{ userStatus }
 * @param {Function} options.onConfirm - 用户点击确定按钮时的回调函数，参数：{ userStatus, checkType? }
 * @param {Boolean} options.showCancelButton - 是否显示取消按钮，默认为true
 * @param {Boolean} options.checkHospital - 是否需要判断是否在指定医院，默认为true
 * @param {Boolean} options.checkPerfectStatus - 是否需要判断劳务是否完善，默认为true
 * @returns {Promise} 返回Promise，resolve时表示检查通过或用户操作完成，返回 { userStatus, checkType? }，reject时表示出错
 */
export async function checkUserStatusByProject(options = {}) {
  const { 
    axios, 
    Dialog, 
    Toast, 
    projectId, 
    encryptedCaseId,
    signType,
    onSuccess, 
    onConfirm, 
    showCancelButton = true, 
    checkHospital = true, 
    checkPerfectStatus = true 
  } = options

  if (!axios) {
    console.error('checkUserStatusByProject: axios参数是必需的')
    return Promise.reject(new Error('axios参数是必需的'))
  }

  // 验证参数：projectId 和 encryptedCaseId 二选一
  if (!projectId && !encryptedCaseId) {
    console.error('checkUserStatusByProject: projectId 和 encryptedCaseId 必须提供其中一个')
    return Promise.reject(new Error('projectId 和 encryptedCaseId 必须提供其中一个'))
  }

  if (projectId && encryptedCaseId) {
    console.error('checkUserStatusByProject: projectId 和 encryptedCaseId 不能同时提供')
    return Promise.reject(new Error('projectId 和 encryptedCaseId 不能同时提供'))
  }

  try {
    // 调用接口获取用户状态（统一使用 getUserStatus 接口）
    const statusApiUrl = Global_apiserver + 'activity/api/casevideo/getUserStatus'
    let statusPostData

    if (projectId) {
      // 传入 projectId，传递 projectId 参数
      statusPostData = {
        head,
        projectId: projectId,
      }
    } else {
      // 传入 encryptedCaseId，传递 encryptedParam 参数
      statusPostData = {
        head,
        encryptedParam: encryptedCaseId,
      }
    }

    if (signType) {
      statusPostData.signType = signType
    }

    const statusRes = await axios.post(statusApiUrl, statusPostData)
    
    if (statusRes.body.status !== 0) {
      const errorMsg = statusRes.body.message || '获取用户状态失败'
      if (Toast) {
        Toast(errorMsg)
      }
      return Promise.reject(new Error(errorMsg))
    }

    const userStatus = statusRes.body.result

    // 第一步：判断用户是否是医生及是否已认证
    if (userStatus.isDoctor !== 1 || userStatus.level !== 2) {
      // 不是医生或未认证
      if (Toast) {
        Toast.clear()
      }
      
      if (!Dialog) {
        console.warn('checkUserStatusByProject: Dialog参数不存在，无法显示弹框')
        if (Toast) {
          Toast('只有通过认证的医生才能进入本页')
        }
        return Promise.reject(new Error('用户未认证'))
      }

      return new Promise((resolve, reject) => {
        Dialog.confirm({
          message: "只有通过认证的医生才能进入本页，去认证页重新认证?",
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: showCancelButton,
          closeOnClickOverlay: false,
        })
          .then(() => {
            // 确定按钮 - 执行回调函数，传递用户状态和 checkType 标识
            const result = { userStatus, checkType: 'auth' }
            if (onConfirm && typeof onConfirm === 'function') {
              onConfirm(result)
            }
            resolve(result)
          })
          .catch(() => {
            // 取消按钮 - 不执行任何操作
            reject(new Error('用户取消操作'))
          })
      })
    }

    // 第二步：判断是否在指定医院（如果需要判断）
    if (checkHospital) {
      if (userStatus.isInSpecifiedHospital !== 1) {
        // 不在指定医院 - 直接返回结果给页面处理，不显示Dialog
        if (Toast) {
          Toast.clear()
        }
        
        // 直接返回结果，让页面自己处理
        const result = { userStatus, checkType: 'hospital' }
        if (onConfirm && typeof onConfirm === 'function') {
          onConfirm(result)
        }
        return Promise.resolve(result)
      }
    }

    // 第三步：判断劳务是否完善（如果需要判断）
    if (checkPerfectStatus) {
      if (userStatus.perfectStatus !== 1) {
        // 劳务未完善
        if (Toast) {
          Toast.clear()
        }
        
        if (!Dialog) {
          console.warn('checkUserStatusByProject: Dialog参数不存在，无法显示弹框')
          if (Toast) {
            Toast('请完善劳务信息')
          }
          return Promise.reject(new Error('用户劳务信息未完善'))
        }

        return new Promise((resolve, reject) => {
          Dialog.confirm({
            title: '提示',
            message: '请完善劳务信息',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: showCancelButton,
            closeOnClickOverlay: false,
          })
            .then(() => {
              // 确定按钮 - 执行回调函数，传递用户状态和 checkType 标识
              const result = { userStatus, checkType: 'perfectStatus' }
              if (onConfirm && typeof onConfirm === 'function') {
                onConfirm(result)
              }
              resolve(result)
            })
            .catch(() => {
              // 取消按钮 - 不执行任何操作
              reject(new Error('用户取消操作'))
            })
        })
      }
    }

    // 所有检查都通过
    if (Toast) {
      Toast.clear()
    }
    const result = { userStatus }
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess(result)
    }
    return Promise.resolve(result)
  } catch (error) {
    // 接口调用失败，清除loading（如果存在）
    if (Toast) {
      Toast.clear()
      Toast('操作失败，请稍后重试')
    }
    console.error('根据项目ID检查用户状态失败:', error)
    return Promise.reject(error)
  }
}